import { Component, OnInit, inject } from '@angular/core';
import { AppConfig } from "app/app.config";
import { LoaderService } from "app/services/loader.service";

import { APIService } from 'app/services/api.service';
import { FormsModule } from '@angular/forms';

type apiNewsletterType = {
  Date: string;
  Image: string;
  Link: string;
  Summary: string;
  Title: string;
};

type newsletterType = {
  formattedDate: string;
  Image: string;
  Link: string;
  Summary: string;
  Title: string;
};

@Component({
    selector: 'nwm-resource-newsletter',
    templateUrl: './resource-newsletter.component.html',
    imports: [FormsModule]
})
export class ResourceNewsletterComponent implements OnInit {
  private api = inject(APIService);
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);

  newsletters: newsletterType[] = [];
  newsletter?: newsletterType;
  selected = '';
  imageBaseUrl: string = this.config.resources.imageBaseUrl;
  contentBaseUrl: string = this.config.resources.contentBaseUrl;


  ngOnInit(): void {
    this.loaderService.display(true, this.constructor.name);
    this.api.get<apiNewsletterType[]>(this.config.resources.newsletterUrl).subscribe(data => {
      this.newsletters = [];
      for (let i = data.length-1; i>=0 && this.newsletters.length < 9; i--) { // take only 2 years of data
        const dataElement = data[i];
        if (dataElement.Title.indexOf('Quarterly') ===0) {
          const date = dataElement.Date.split('-');
          this.newsletters.push({
            formattedDate: date[0] + ' Q' + Math.ceil(+date[1] / 3),
            Image: dataElement.Image,
            Link: dataElement.Link,
            Summary: dataElement.Summary,
            Title: dataElement.Title,
          });
        }
      }
      this.newsletter = this.newsletters.shift();

      this.loaderService.display(false, this.constructor.name);
    },
    () => this.loaderService.display(false, this.constructor.name)
    );
  }

  download() {
    if (this.selected !== '') {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = this.selected;
      a.download = this.selected.substring(this.selected.lastIndexOf('/')+1);
      a.target = "_blank";
      a.click();
      a.remove();
    }
  }
}